export default __webpack_public_path__ + "static/media/TJ.471164e1.svg";